// Gpr ads managements
// Bertrand Dessemond
jQuery(document).ready(function($) {

    /**
    * Extension la taille des champs de la fiche DCI
    */
    $.fn.fieldHeight = function() {
        var col2 ;
        var col1 ;
        $('.fiche_dci .fiche_dci_row ').each(function(index, el) {
          col1 = $('.col-md-4',el);
          col2 = $('.col-md-8',el);
          fieldToGrow = $('.col-md-8 .info_content',el);
          if(col1.height() > col2.height() ) {
              new_height = col1.height();  // On enleve le padding haut / bas )
              // fieldToGrow.height(new_height - 20 );
              //fieldToGrow.css('min-height', new_height+'px');
              fieldToGrow.attr('style','min-height:' + new_height + 'px');

              // console.log('FIELD HEIGHT');
          }

        });
    };

    /**
    * Slide lors des clic bouton des recherches DCIS
    */
    $.fn.slideTo = function(options) {
      var settings = $.extend({
                target:''
             }, options );

      $('html, body').animate({
          scrollTop: $(settings.target).offset().top - 35
      }, 600);
    };
      //Tooltips d'info pour la DFG
      $.fn.checkDfg = function (){
      var value = $('input#dfg').val();
      if (value !== '') {
          value = parseFloat(value);
          if (value < 1){
            $('#dfg[data-toggle="tooltip"]').tooltip('show');
            return false;
          }
          else if (value > 90) {
            $('#dfg[data-toggle="tooltip"]').tooltip('show');
            return false;
          }
          else {
            $('#dfg[data-toggle="tooltip"]').tooltip('hide');
            return true;
          }
      } else {
          $('#dfg[data-toggle="tooltip"]').tooltip('show');
          return false;
      }
    };


    //Gestion du click sur le bouton DFG pour la recherche de MED
    $(document).on('click', '.display_way, .display_way_dfg', function(event) {
      // fix IE8
      event.preventDefault ? event.preventDefault() : (event.returnValue = false); // jshint ignore:line
      // event.preventDefault();
      // console.log('Click btn dialyse');
      $('.list_voies_admin').hide();
      $('.fiche_dci').html('');
      var displayNext = false;
      if($(this).hasClass('display_way_dfg') ) {
          //console.log("DISPLAY WAY FG");
          displayNext = $(this).checkDfg() ;
      } else {
          displayNext = true;
      }
      if(displayNext) {
          $('#dfg[data-toggle="tooltip"]').tooltip('hide');
          // $('#dfg[data-toggle="tooltip"]').tooltip('hide');
          $('.list_voies_admin').hide();
          $('.fiche_dci').html('');
          $(".display_way, .bloc-dfg, .list-btn-voies a").removeClass('active');

          $(this).closest('.bloc-dialyse').addClass('active');
          if( $('.list_voies_admin li').length  > 0){
            $('.list_voies_admin').fadeIn('fast').slideTo({target:'.list_voies_admin'});
          } else if( $('.fiche_dci').is(':empty') ) {
              // patch pour Diffu k"
              $('.fiche_dci').html('<h2>'+gpr.no_result+'</h2>');

          }

      }
    });

    //Send stat RCP
    $(document).on('click', '.rcp-link', function(){
        var url = $(this).data('href');
        var search = $(this).data('search');

         $.ajax({
             url: gpr.ajaxurl,
             type: 'POST',
             data: {
                 action: 'stats_rcp',
                 search: search
             },
             success: function (data) {
                window.open(url, '_blank');
             }
         });
    });
});
